import React from 'react';
import PropTypes from 'prop-types';

import {
	TextComponent,
	PictogramComponent,
	SlotContainer,
	BlankComponent,
} from './styles';
import Image from './Image';

const components = {
	image: Image,
	text: TextComponent,
	pictogram: PictogramComponent,
	accessibility: BlankComponent,
	contacts: BlankComponent,
	blank: BlankComponent,
}

const Slot = ({ top, left, width, height, component, data, layout }) => {
	const Component = components[component];

	return (
		<SlotContainer
			top={top}
			left={left}
			width={width}
			height={height}
		>
			<Component data={data} layout={layout} />
		</SlotContainer>
	)
}

Slot.propTypes = {
	top: PropTypes.number,
	left: PropTypes.number,
	width: PropTypes.number,
	height: PropTypes.number,
	component: PropTypes.string,
	data: PropTypes.oneOfType([
		PropTypes.array,
		PropTypes.object
	]),
	layout: PropTypes.string,
}

export default Slot
